import { render, staticRenderFns } from "./toolbox.vue?vue&type=template&id=66fb24c2&scoped=true&"
import script from "./toolbox.vue?vue&type=script&lang=ts&"
export * from "./toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./toolbox.vue?vue&type=style&index=0&id=66fb24c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb24c2",
  null
  
)

export default component.exports